import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-sparkline',
  standalone: false,
  templateUrl: './sparkline.html',
})
export class Sparkline {
  @Input() values: number[] = [];
  @Input() variant: 'blue' | 'muted' = 'blue';

  private readonly W = 120;
  private readonly H = 32;
  private readonly PAD = 3;

  get points(): string {
    if (!this.values.length) return '';
    const max = Math.max(...this.values, 0);
    const min = Math.min(...this.values, 0);
    const range = max - min || 1;
    const step = this.values.length > 1 ? (this.W - this.PAD * 2) / (this.values.length - 1) : 0;
    return this.values
      .map((v, i) => {
        const x = this.PAD + step * i;
        const y = this.PAD + (this.H - this.PAD * 2) * (1 - (v - min) / range);
        return `${x.toFixed(1)},${y.toFixed(1)}`;
      })
      .join(' ');
  }

  get endPoint(): { x: number; y: number } | null {
    if (!this.values.length) return null;
    const parts = this.points.split(' ');
    const [x, y] = parts[parts.length - 1].split(',').map(Number);
    return { x, y };
  }
}
